/**
 * Configuration file for Google Analytics
 *
 * This file is where you define overrides for the default google parameters.
 */

export default {
  measurementId: 'G-1DLB3EMYYD',

  // Restricted in the Google API console to our organization sites. Map API keys are pseudo-public. They are available
  // on any site that needs to use Google Maps by snooping the developer console.
  mapApiKey: 'AIzaSyC5i3i-QZ53KpZsxi_qpOA89fP3evwmNx4',
  enabled: false
};
